module.exports = __webpack_public_path__ + "media/newstyle/images/70-mil-authors-dc2995253c5a7b18ab18bf4dc7a29ee0.svg";